import { untrack, type Accessor } from "solid-js"
import type { Entity } from "../../entity/index"
import type { PlayerIdOrNull } from "../../player/PlayerIdOrNull"
import type { PlayerGraphNode } from "../PlayerGraphNode/PlayerGraphNode.type"
import type { TileGraphNode } from "../TileGraphNode/TileGraphNode.type"
import type { EntityGraphNode } from "./EntityGraphNode.type"

export default function createEntityGraphNode<T extends Entity = Entity>(
  getRawEntity: Accessor<T>,
  tile: TileGraphNode,
  player: PlayerGraphNode,
  getColor1: Accessor<number>,
  getColor2: Accessor<number>,
  getPlayerId: Accessor<PlayerIdOrNull>,
): EntityGraphNode<T> {
  // Initialize static properties that won't change during the entity's lifetime
  // Using untrack to avoid creating unnecessary reactive dependencies
  const value = untrack(getRawEntity)
  const node: EntityGraphNode<T> = {
    raw: getRawEntity,
    /**
     * These properties are set once during initialization and never change.
     * If an entity needs to change these properties, it should be replaced with a new entity.
     * This is a performance optimization to avoid tracking properties that won't change.
     */
    id: value.id,
    etype_id: value.etype_id,
    layer_id: value.layer_id,
    tile,
    player,
    color1: getColor1,
    color2: getColor2,
    player_id: getPlayerId,
  }
  return node
}
  